import Send from '../common.client.js'

//주석정의방법 : 컨트롤러 메소드명 - 메소드에 대한 간단 주석 - REST URI
export default {
  //network - 고객센터 > Network - GET /common/network
  getNetworkInfo () {
    return Send({
      url: '/common/network',
      method: 'get',
      params: {
      }
    })
  },
  //findNetworkOffices - 고객센터 > Network 사무소/AREA/담당자 (WB320I/WB321I/WB322I) - GET /common/network/offices
  getNetworkOffices (ctrCd) {
    return Send({
      url: '/common/network/offices',
      method: 'get',
      params: {
        ctrCd: ctrCd
      }
    })
  },
  //findNetworkOfficesAdm - 편집 권한자용 사무소/AREA/담당자 조회 (미사용 USE_YN='N' 포함) - GET /common/admins/network/offices
  getNetworkOfficesAdm (ctrCd) {
    return Send({
      url: '/common/admins/network/offices',
      method: 'get',
      params: {
        ctrCd: ctrCd
      }
    })
  },
  //findNetworkRole - Network 편집 권한 (CM112I — 00526:전 국가 / 00527:자국만, JWT ADMIN=전 국가) - GET /common/admins/network/role
  getNetworkRole () {
    return Send({
      url: '/common/admins/network/role',
      method: 'get'
    })
  },
  //saveNetwork - 관리자 > Network 사무소/AREA/담당자 일괄저장 (state C/U/D, 편집 권한자 전용) - PUT /common/admins/network/save
  saveNetworkAdmin (data) {
    return Send({
      url: '/common/admins/network/save',
      method: 'put',
      data: data
    })
  }
}
